class w {
  constructor() {
    this.presets = /* @__PURE__ */ new Map(), this.byCategory = /* @__PURE__ */ new Map(), this.initialized = !1;
  }
  /**
   * Register a preset in the registry
   */
  register(e) {
    this.presets.has(e.id) && console.warn(`Preset "${e.id}" is already registered. Overwriting.`), this.presets.set(e.id, e);
    const s = this.byCategory.get(e.category) || [], a = s.findIndex((r) => r.id === e.id);
    a >= 0 ? s[a] = e : s.push(e), this.byCategory.set(e.category, s);
  }
  /**
   * Register multiple presets at once
   */
  registerAll(e) {
    e.forEach((s) => this.register(s));
  }
  /**
   * Get a preset by ID
   */
  get(e) {
    return this.presets.get(e);
  }
  /**
   * Check if a preset exists
   */
  has(e) {
    return this.presets.has(e);
  }
  /**
   * Get all presets in a category
   */
  getByCategory(e) {
    return this.byCategory.get(e) || [];
  }
  /**
   * Get all available categories that have presets
   */
  getCategories() {
    return Array.from(this.byCategory.keys());
  }
  /**
   * Search presets by query string
   * Searches in name, description, and tags
   */
  search(e) {
    const s = e.toLowerCase().trim();
    return s ? Array.from(this.presets.values()).filter(
      (a) => a.name.toLowerCase().includes(s) || a.description.toLowerCase().includes(s) || a.tags.some((r) => r.toLowerCase().includes(s)) || a.id.toLowerCase().includes(s)
    ) : this.getAll();
  }
  /**
   * Get all preset IDs
   */
  getAllIds() {
    return Array.from(this.presets.keys());
  }
  /**
   * Get all presets
   */
  getAll() {
    return Array.from(this.presets.values());
  }
  /**
   * Get count of registered presets
   */
  get count() {
    return this.presets.size;
  }
  /**
   * Clear all registered presets
   */
  clear() {
    this.presets.clear(), this.byCategory.clear(), this.initialized = !1;
  }
  /**
   * Mark registry as initialized (after loading all presets)
   */
  markInitialized() {
    this.initialized = !0;
  }
  /**
   * Check if registry is initialized
   */
  get isInitialized() {
    return this.initialized;
  }
  /**
   * Get presets grouped by category
   */
  getGroupedByCategory() {
    return new Map(this.byCategory);
  }
  /**
   * Find presets similar to a given preset (same category, shared tags)
   */
  findSimilar(e, s = 5) {
    const a = this.get(e);
    return a ? this.getByCategory(a.category).filter(
      (n) => n.id !== e
    ).map((n) => ({
      preset: n,
      score: n.tags.filter((o) => a.tags.includes(o)).length
    })).sort((n, o) => o.score - n.score).slice(0, s).map((n) => n.preset) : [];
  }
}
const d = new w();
function T(t) {
  d.register(t);
}
function j(t) {
  d.registerAll(t);
}
const x = {
  fonts: {
    display: '"Inter var", "Inter", system-ui, sans-serif',
    heading: '"Inter var", "Inter", system-ui, sans-serif',
    body: '"Inter var", "Inter", system-ui, sans-serif',
    mono: '"JetBrains Mono", "Fira Code", "SF Mono", monospace'
  },
  headings: {
    letterSpacing: "tight",
    weight: "semibold"
  },
  microLabels: {
    letterSpacing: "wide",
    weight: "medium",
    casing: "uppercase",
    size: "xs"
  }
}, E = {
  density: "comfortable",
  paddingScale: 1,
  gapScale: 1,
  sectionSpacing: "normal"
}, S = {
  defaultVariant: "elevated",
  radius: "lg",
  showBorder: !0,
  borderStyle: "subtle",
  accentEdge: "none",
  elevation: 1,
  hoverEffect: "lift"
}, V = {
  sequential: ["#EEF2FF", "#C7D2FE", "#818CF8", "#4F46E5", "#3730A3"],
  categorical: ["#6366F1", "#10B981", "#F59E0B", "#EF4444", "#8B5CF6", "#EC4899", "#14B8A6", "#F97316"],
  diverging: {
    negative: "#EF4444",
    neutral: "#6B7280",
    positive: "#10B981"
  },
  semantic: {
    positive: "#10B981",
    negative: "#EF4444",
    neutral: "#6B7280",
    warning: "#F59E0B"
  }
}, z = {
  metricSize: "3xl",
  metricWeight: "semibold",
  showTrendArrows: !0,
  sparklineStyle: "area",
  cardTreatment: "elevated"
}, B = {
  primary: "245 82% 60%",
  // Indigo
  secondary: "158 64% 42%",
  // Teal
  application: {
    buttons: "filled",
    links: "color-only",
    focus: "ring",
    selection: "subtle"
  }
}, F = {
  style: "smooth",
  interactionScale: {
    hover: 1.02,
    press: 0.98
  },
  pageTransitions: !0,
  listAnimation: "fade"
}, P = {
  Button: {
    variant: "primary",
    size: "md",
    pressable: !0
  },
  Card: {
    variant: "elevated",
    padding: "md",
    hoverable: !1
  },
  Badge: {
    style: "soft",
    size: "md"
  },
  Input: {
    variant: "default"
  },
  DataTable: {
    density: "comfortable",
    stripedRows: !1,
    showRowBorders: !0
  },
  KpiCard: {
    elevated: !0
  },
  Typography: {
    display: !1,
    gradient: !1
  },
  Alert: {
    variant: "info"
  },
  Modal: {
    size: "md"
  },
  Tabs: {
    variant: "underline"
  }
}, D = {
  mode: "light",
  density: "comfortable",
  motion: "smooth"
}, M = {
  typography: x,
  spacing: E,
  cards: S,
  dataViz: V,
  kpiStyling: z,
  accents: B,
  motion: F,
  componentDefaults: P,
  dataAttributes: D,
  cssVariables: {}
};
function u(t, e) {
  const s = { ...t };
  for (const a in e) {
    const r = e[a], i = t[a];
    r !== void 0 && typeof r == "object" && r !== null && !Array.isArray(r) && typeof i == "object" && i !== null && !Array.isArray(i) ? s[a] = u(
      i,
      r
    ) : r !== void 0 && (s[a] = r);
  }
  return s;
}
const y = {
  compact: "0.5rem",
  comfortable: "0.75rem",
  spacious: "1rem",
  relaxed: "1.25rem"
}, h = {
  none: "0px",
  sm: "0.25rem",
  md: "0.375rem",
  lg: "0.5rem",
  xl: "0.75rem",
  "2xl": "1rem",
  "3xl": "1.5rem",
  full: "9999px"
};
function I(t) {
  const e = {};
  e["--font-display"] = t.typography.fonts.display, e["--font-heading"] = t.typography.fonts.heading, e["--font-sans"] = t.typography.fonts.body, e["--font-body"] = t.typography.fonts.body, e["--font-mono"] = t.typography.fonts.mono, e["--ds-density-padding"] = y[t.spacing.density], e["--ds-density-gap"] = `calc(${y[t.spacing.density]} * ${t.spacing.gapScale})`, e["--ds-padding-scale"] = String(t.spacing.paddingScale), e["--ds-gap-scale"] = String(t.spacing.gapScale), e["--shape-radius-default"] = h[t.cards.radius], e["--ds-card-radius"] = h[t.cards.radius];
  const s = {
    0: "none",
    1: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
    2: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
    3: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)"
  };
  e["--ds-card-shadow"] = s[t.cards.elevation] || "none", e["--ds-primary"] = t.accents.primary, t.accents.secondary && (e["--ds-secondary"] = t.accents.secondary), e["--ds-text"] = "var(--ds-foreground)", e["--ds-surface-foreground"] = "var(--ds-foreground)", e["--ds-card-foreground"] = "var(--ds-foreground)", e["--ds-popover-foreground"] = "var(--ds-foreground)", e["--ds-secondary-foreground"] = "var(--ds-foreground)", e["--ds-accent-foreground"] = "var(--ds-foreground)", t.dataViz.categorical.forEach((r, i) => {
    e[`--ds-chart-${i + 1}`] = r;
  }), e["--ds-semantic-positive"] = t.dataViz.semantic.positive, e["--ds-semantic-negative"] = t.dataViz.semantic.negative, e["--ds-semantic-neutral"] = t.dataViz.semantic.neutral, e["--ds-semantic-warning"] = t.dataViz.semantic.warning;
  const a = {
    minimal: "100ms",
    smooth: "200ms",
    playful: "300ms"
  };
  return e["--ds-motion-duration"] = a[t.motion.style] || "200ms", e["--ds-motion-hover-scale"] = String(t.motion.interactionScale.hover), e["--ds-motion-press-scale"] = String(t.motion.interactionScale.press), { ...e, ...t.cssVariables };
}
function $(t, e) {
  const s = d.get(t);
  if (!s)
    throw new Error(`Preset "${t}" not found in registry. Available presets: ${d.getAllIds().join(", ")}`);
  let a = u(
    { ...M, id: s.id, name: s.name, description: s.description, category: s.category, tags: s.tags, version: s.version },
    s
  );
  e && (a = u(a, e));
  const r = I(a);
  return {
    ...a,
    computedCssVariables: r
  };
}
function b(t, e) {
  try {
    return $(t, e);
  } catch {
    return;
  }
}
function k(t, e) {
  const s = d.get(t);
  return s ? s.componentDefaults[e] || {} : {};
}
function R(t) {
  const e = b(t);
  return {
    preset: e,
    getDefaults: (s) => e ? e.componentDefaults[s] || {} : {},
    getCssVariables: () => (e == null ? void 0 : e.computedCssVariables) || {}
  };
}
const l = /* @__PURE__ */ new WeakMap();
function v(t, e = {}) {
  if (typeof document > "u") return null;
  const {
    target: s = document.documentElement,
    applyDataAttributes: a = !0,
    applyCssVariables: r = !0,
    overrides: i
  } = e;
  A(s);
  const n = b(t, i);
  if (!n)
    return console.warn(`Failed to apply preset "${t}": not found`), null;
  const o = {
    presetId: t,
    appliedVariables: [],
    appliedAttributes: []
  };
  if (r && Object.entries(n.computedCssVariables).forEach(([c, g]) => {
    s.style.setProperty(c, g), o.appliedVariables.push(c);
  }), a && n.dataAttributes) {
    const c = n.dataAttributes;
    [
      ["mode", "data-mode"],
      ["style", "data-style"],
      ["brand", "data-brand"],
      ["personality", "data-personality"],
      ["density", "data-density"],
      ["motion", "data-motion"]
    ].forEach(([C, f]) => {
      const m = c[C];
      m && (s.setAttribute(f, m), o.appliedAttributes.push(f));
    });
  }
  return s.setAttribute("data-preset", t), o.appliedAttributes.push("data-preset"), l.set(s, o), n;
}
function A(t = document.documentElement) {
  const e = l.get(t);
  e && (e.appliedVariables.forEach((s) => {
    t.style.removeProperty(s);
  }), e.appliedAttributes.forEach((s) => {
    t.removeAttribute(s);
  }), l.delete(t));
}
function p(t = document.documentElement) {
  return t.getAttribute("data-preset");
}
function L(t, e = document.documentElement) {
  return p(e) === t;
}
function q(t, e = document.documentElement) {
  const s = l.get(e);
  Object.entries(t).forEach(([a, r]) => {
    e.style.setProperty(a, r), s && !s.appliedVariables.includes(a) && s.appliedVariables.push(a);
  });
}
function O(t, e, s = {}) {
  const { target: a = document.documentElement } = s, r = p(a);
  return r && r !== t && console.warn(
    `Expected preset "${t}" but found "${r}". Switching anyway.`
  ), v(e, s);
}
function K(t) {
  return {
    apply: (e, s) => v(e, { ...s, target: t }),
    remove: () => A(t),
    getCurrentId: () => p(t),
    isApplied: (e) => L(e, t)
  };
}
export {
  j as a,
  $ as b,
  R as c,
  v as d,
  A as e,
  p as f,
  k as g,
  K as h,
  L as i,
  M as j,
  x as k,
  E as l,
  S as m,
  V as n,
  z as o,
  d as p,
  B as q,
  T as r,
  O as s,
  b as t,
  q as u,
  F as v,
  P as w,
  D as x,
  u as y
};
